import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[dateMask]'
})
export class DateMaskDirective {
  constructor(private el: ElementRef, private control: NgControl) {
  }

  @HostListener('keyup', ['$event']) onKeydown($event: KeyboardEvent) {
    if ($event.key === 'Backspace' || $event.key === 'Delete') {
      return;
    } else {
      this.updateValue();
    }
  }

  private updateValue() {
    const value = this.el.nativeElement.value;
    const formattedValue = this.formatValue(value);
    this.control.control.setValue(formattedValue);
  }

  private formatValue(input: string) {
    let result = '';
    const numberPattern = /\d+/g;
    const matches = input.match(numberPattern);
    if (!input || !matches) {
      return '';
    }

    const numbers = matches.join('').slice(0, 8);
    numbers.split('').forEach((value, index) => {
      if (index === 1) {
        result = result + `${value}/`;
      } else if (index === 3) {
        result = result + `${value}/`;
      } else {
        result = result + value;
      }
    });

    return result;
  }

}
